export default __webpack_public_path__ + "static/media/transponder-white.14512c04.png";